/** The operator console: for the people who run the platform and host customers. */
export const enOperator = {
  'o.title': 'Operator console',
  'o.nav': 'Sections',
  'o.email': 'Email',
  'o.password': 'Password',
  'o.login.sub': 'Sign in with your operator account. This is separate from any restaurant dashboard.',
  'o.login.go': 'Sign in',
  'o.logout': 'Sign out',
  'o.tab.customers': 'Customers',
  'o.tab.plans': 'Plans',
  'o.tab.invoices': 'Invoices',
  'o.status.active': 'Active',
  'o.status.trial': 'Trial',
  'o.status.suspended': 'Suspended',
  'o.status.cancelled': 'Cancelled',
  'o.status.draft': 'Draft',
  'o.status.open': 'Open',
  'o.status.paid': 'Paid',
  'o.status.void': 'Void',
  'o.trial_until': 'until {date}',
  'o.search': 'Search customers',
  'o.new_customer': '+ New customer',
  'o.none': 'Nothing here yet.',
  'o.col.customer': 'Customer',
  'o.col.status': 'Status',
  'o.col.plan': 'Plan',
  'o.col.bookings': 'Bookings this month',
  'o.col.domains': 'Domains',
  'o.col.since': 'Customer since',
  'o.bookings_one': '{n} booking',
  'o.bookings_other': '{n} bookings',
  'o.cancel': 'Cancel',
  'o.close': 'Close',
  'o.done': 'Done',
  'o.save': 'Save',
  'o.saved': 'Saved.',
  'o.copy': 'Copy',
  'o.copied': 'Copied.',
  'o.nc.intro': 'Creates the restaurant with a small working start (one dining room, six tables, lunch and dinner), the look you choose and an owner account. The customer changes everything else in their own dashboard.',
  'o.nc.name': 'Restaurant name',
  'o.nc.timezone': 'Time zone',
  'o.nc.currency': 'Currency',
  'o.nc.locale': 'Main language',
  'o.nc.owner_email': 'Owner email',
  'o.nc.owner_name': 'Owner name',
  'o.nc.legal': 'Company name',
  'o.nc.address': 'Address',
  'o.nc.phone': 'Phone',
  'o.nc.contact_email': 'Contact email',
  'o.nc.website': 'Website',
  'o.nc.look': 'Starting look',
  'o.nc.plan': 'Plan',
  'o.nc.no_plan': 'No plan yet',
  'o.nc.trial': 'Trial days',
  'o.nc.billing_email': 'Billing email',
  'o.nc.create': 'Create customer',
  'o.created.title': 'Customer created',
  'o.created.body': 'Hand these details to the customer. The password is shown only now.',
  'o.created.owner': 'Owner',
  'o.created.password': 'Password',
  'o.created.dashboard': 'Dashboard',
  'o.created.page': 'Booking page',
  'o.created.embed': 'Website code',
  'o.d.links': 'Links',
  'o.d.account': 'Account',
  'o.d.status': 'Status',
  'o.d.trial_end': 'Trial ends',
  'o.d.company': 'Company for invoices',
  'o.d.notes': 'Internal notes',
  'o.d.reason': 'Reason shown internally',
  'o.d.domains': 'Own domain',
  'o.d.domains_hint': 'The customer\'s booking page can run on their own address. Add the domain, create the DNS record shown, then verify. Point the domain at {host}.',
  'o.d.hostname': 'Domain name',
  'o.d.add_domain': 'Add domain',
  'o.d.no_domains': 'No domain connected.',
  'o.d.verified': 'Verified',
  'o.d.pending': 'Waiting for DNS',
  'o.d.txt_hint': 'Create this DNS record at the domain\'s provider, then press Verify:',
  'o.d.verify': 'Verify',
  'o.d.verified_ok': 'Domain verified. It now serves this customer.',
  'o.d.verified_no': 'The DNS record was not found yet. It can take a while to appear.',
  'o.d.remove': 'Remove',
  'o.d.remove_confirm': 'Remove this domain? The customer\'s page stops answering on it.',
  'o.d.owners': 'Owner accounts',
  'o.d.new_password': 'Issue new password',
  'o.d.password_confirm': 'Issue a new password for {email}? Their current sessions end.',
  'o.d.password_shown': 'New password for {email} (copy it now, it is not shown again):',
  'o.d.usage': 'Bookings per month',
  'o.d.invoices': 'Invoices',
  'o.d.no_invoices': 'No invoices yet.',
  'o.p.intro': 'Plans define the monthly price, how many bookings are included and what each extra booking costs. Only active plans can be chosen for new customers.',
  'o.p.name': 'Name',
  'o.p.price': 'Monthly price',
  'o.p.included': 'Bookings included',
  'o.p.overage': 'Price per extra booking',
  'o.p.active': 'Active',
  'o.p.add': '+ Add plan',
  'o.p.new': 'New plan',
  'o.i.period': 'Month',
  'o.i.run': 'Create or refresh drafts',
  'o.i.ran': '{drafted} drafted, {skipped} skipped.',
  'o.i.hint': 'Drafts are calculated from the month\'s non-cancelled bookings and can be refreshed. Issuing assigns the legal number and freezes the document; a mistake is corrected with a credit note. Customers in a running trial are skipped.',
  'o.i.all': 'All',
  'o.i.lines': 'Lines',
  'o.i.total': 'Total',
  'o.i.issue': 'Issue',
  'o.i.paid': 'Mark paid',
  'o.i.void': 'Void',
  'o.i.void_confirm': 'Void this invoice?',
  'o.tab.settings': 'Invoice settings',
  'o.status.issued': 'Issued',
  'o.status.credited': 'Credited',
  'o.vat.auto': 'Automatic',
  'o.vat.standard': 'Standard VAT',
  'o.vat.reverse_charge': 'Reverse charge',
  'o.vat.outside_scope': 'Outside VAT scope',
  'o.vat.exempt': 'VAT exempt',
  'o.collection.manual': 'Manual (bank transfer)',
  'o.collection.auto': 'Automatic (saved card or debit)',
  'o.d.billing_data': 'Billing details',
  'o.d.billing_address': 'Billing address',
  'o.d.country': 'Country (ISO code)',
  'o.d.vat_id': 'VAT ID',
  'o.d.vat_treatment': 'VAT treatment',
  'o.d.collection': 'Payment collection',
  'o.d.method': 'Payment method',
  'o.d.method_saved': 'Saved',
  'o.d.method_none': 'No card or bank account saved yet.',
  'o.d.method_link': 'Create link to save a method',
  'o.d.method_replace': 'Create link to replace it',
  'o.d.method_forget': 'Remove saved method',
  'o.d.method_hint': 'Send the link to the customer. They enter their details on the payment provider\'s own page; this server never sees them.',
  'o.d.no_provider': 'Automatic collection is not set up on this server. Invoices are paid by transfer and marked paid by hand.',
  'o.d.method_link_shown': 'Send this link to the customer (copy it now):',
  'o.d.method_forget_confirm': 'Remove the saved method? The customer is switched back to manual payment.',
  'o.i.no_number': 'Draft',
  'o.i.credit_note': 'Credit note',
  'o.i.issuer_missing': 'Invoices cannot be issued until your company details are complete.',
  'o.i.number': 'Number',
  'o.i.net': 'Net',
  'o.i.vat': 'VAT',
  'o.i.collect': 'Charge now',
  'o.i.credit': 'Credit note',
  'o.i.delete': 'Delete draft',
  'o.i.delete_confirm': 'Delete this draft?',
  'o.i.credit_confirm': 'Cancel this invoice with a credit note? This cannot be undone.',
  'o.i.issued': 'Issued as {number}.',
  'o.i.credited': 'Credit note {number} created.',
  'o.i.collect_paid': 'Paid.',
  'o.i.collect_processing': 'The payment is processing; it is marked paid when the provider confirms.',
  'o.i.collect_failed': 'The payment did not go through. See the message on the invoice.',
  'o.i.collect_skipped': 'Nothing to charge: no saved method, or the invoice is not open.',
  'o.s.title': 'Who issues the invoices',
  'o.s.hint': 'These details appear on every invoice and credit note. Invoices cannot be numbered until the company name, address, country and a VAT ID or tax number are filled in.',
  'o.s.missing': 'Still missing: {fields}.',
  'o.s.f.legalName': 'Company name',
  'o.s.f.country': 'Country (ISO code)',
  'o.s.f.vatId': 'VAT ID',
  'o.s.f.taxNumber': 'Tax number',
  'o.s.f.address': 'Address',
  'o.s.f.email': 'Email',
  'o.s.f.phone': 'Phone',
  'o.s.f.website': 'Website',
  'o.s.f.bankName': 'Bank',
  'o.s.f.iban': 'IBAN',
  'o.s.f.bic': 'BIC',
  'o.s.f.vatRate': 'Standard VAT rate (%)',
  'o.s.f.terms': 'Payment term (days)',
  'o.s.f.invoicePrefix': 'Invoice number prefix',
  'o.s.f.creditPrefix': 'Credit note prefix',
  'o.s.f.exemptNote': 'Wording when VAT-exempt',
  'o.s.f.footerNote': 'Invoice footer',
  'o.s.bank': 'Bank details',
  'o.s.rules': 'VAT and numbering',
  'o.s.advice': 'Numbers run without gaps per year and series (for example RE-2026-00001). The VAT treatment is a helper based on the usual rules for software services between businesses in the EU. Have your accountant confirm the settings before you issue real invoices.',
  'o.s.provider': 'Automatic collection',
  'o.s.provider_on': 'Connected: {name}.',
  'o.s.provider_off': 'Not connected. Set BILLING_STRIPE_SECRET_KEY and BILLING_WEBHOOK_SECRET on the server to collect by card or debit.',
  'o.i.zugferd_title': 'PDF with the invoice data attached as XML (ZUGFeRD / Factur-X)',
  'o.i.xr_title': 'XML invoice for German e-invoicing (XRechnung)',
  'o.tab.health': 'System',
  'o.h.none': 'Health data could not be loaded.',
  'o.h.db': 'Database',
  'o.h.down': 'Not reachable',
  'o.h.sweep': 'Background jobs last ran',
  'o.h.started': 'Server started',
  'o.h.alerts': 'Alerts to your phone or chat',
  'o.h.on': 'On',
  'o.h.off': 'Off',
  'o.h.emails_pending': 'Emails waiting',
  'o.h.emails_failed': 'Emails failed (24 h)',
  'o.h.sms_failed': 'Texts failed (24 h)',
  'o.h.hooks_failed': 'Webhooks failed (24 h)',
  'o.h.invoices_failed': 'Invoices not collected',
  'o.h.alerts_hint': 'Set ALERT_WEBHOOK_URL (a Slack, Teams or Discord webhook) on the server to be told when something breaks, even when nobody has this page open.',
  'o.h.problems': 'Recent problems',
  'o.h.no_problems': 'Nothing has gone wrong since the server started.',
  'o.d.dummy': 'Sample data',
  'o.d.dummy_hint': 'For test restaurants only: fills the restaurant with floor plans, tables, shifts, guests, bookings from the last three weeks and the next two, sales, a menu and private dining. It replaces the layout and shifts (the previous version stays in History). Refused if real reservations exist.',
  'o.d.dummy_load': 'Load sample data',
  'o.d.dummy_remove': 'Remove sample data',
  'o.d.dummy_confirm': 'Load sample data into this restaurant? Its layout and shifts are replaced.',
  'o.d.dummy_working': 'Loading… this takes up to a minute.',
  'o.d.dummy_done': 'Done: {guests} guests, {bookings} bookings, {tables} tables.',
  'o.d.dummy_remove_confirm': 'Remove all sample guests, bookings and sales again? The layout and shifts stay.',
  'o.d.dummy_removed': 'Removed {n} items.',
  'o.i.email': 'Send by email',
  'o.i.emailed': 'Emailed to {to}',
  'o.i.email_failed': 'Email not sent: {error}',
  'o.i.email_sent': 'Email sent with the PDF attached.',
  'o.i.email_not_sent': 'The email could not be sent. See the message on the invoice.',
  'o.d.link': 'Link accounts',
  'o.d.link_hint': 'Let this person switch between all restaurants where they use this email, without signing in again.',
  'o.d.linked': '{n} account links created.',
} as const;
